import { render } from "./FinancialManagementPage.vue?vue&type=template&id=044dd5c2"
import script from "./FinancialManagementPage.vue?vue&type=script&lang=js"
export * from "./FinancialManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__